import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const IconWrapper = styled.div`
  width: 38px;
  height: 38px;
  background: rgba(249, 99, 2, 0.2);
  margin-right: 17px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const Content = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  max-width: 280px;
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: ${({ theme }) => theme.colors.mainDarkBlue};
  margin-bottom: 4px;
`;
export const Text = styled.p`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.lightBlue};
`;
